import React from "react";
import { useAppMeta } from "hooks";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import ConsolidationForm from "./ConsolidationComponents/ConsolidationForm";

import {
  useGetConsolidationDetailQuery,
  useUpdateConsolidationMutation,
} from "store/services/consolidationApi";

const ConsolidationEditScreen = () => {

  const { id } = useParams();

  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Consolidation", path: "/app/crm/consolidation/list" },
    { title: "Edit Consolidation" },
  ];

  const {
    data: consolidationDetail,
    isLoading: loadingConsolidation,
    error,
  } = useGetConsolidationDetailQuery(id);

  const [updateConsolidation, { isLoading: updatingConsolidation }] =
    useUpdateConsolidationMutation();

  const handleUpdateConsolidation = async (data) => {
    const _payload = { ...data };

    try {
      await updateConsolidation(_payload).unwrap();
      toast.success("Consolidation successfully updated!");
      navigate(`/app/crm/consolidation/${id}/detail`);
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? "Couldn't update Consolidation!"
      );
    }
  };

  useAppMeta("Edit Consolidation");

  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      isBusy={loadingConsolidation || updatingConsolidation}
    >
      <BreadcrumbLayout.Error error={error} />

      <BreadcrumbLayout.Paper>
        <ConsolidationForm
          isBusy={loadingConsolidation || updatingConsolidation}
          consolidationDetail={consolidationDetail}
          onSubmit={handleUpdateConsolidation}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default ConsolidationEditScreen;
